import { styled } from 'styled-components';
import { StoredQuestion } from '~/gql/questions/questions';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
//import { RenderActivity } from '~/components/game/render-activity';
import { IStateAnswer, IStateAnswerWithImage } from '~/data/types';
import { StoredTheme } from '~/gql/theme/theme';
import iconLost from '@assets/images/icon/icon-trophee-lost.png';
import iconGold from '@assets/images/icon//icon-trophee-gold.png';
import iconNeutral from '@assets/images/icon//icon-trophee-neutral.png';
import Qcu from '~/components/game/qcu';

type IProps = {
  questions: StoredQuestion[];
  onFinish: () => void;
  trackingId: string;
  initStateAnswer?: IStateAnswer[];
  theme: StoredTheme;
  onTurnChange: (nb: number) => void;
  setIsCompleted: Dispatch<SetStateAction<boolean>>;
  setResponsesPercent: Dispatch<SetStateAction<number | null>>;
  onNewPosition: (nb: number | undefined) => void;
  lastQuestion?: boolean;
};

type TProps = IProps;

const initState: IStateAnswerWithImage[] = [
  {
    nb: 0,
    image: iconNeutral,
  },
  {
    nb: 1,
    image: iconNeutral,
  },
  {
    nb: 2,
    image: iconNeutral,
  },
];

export function RenderQuestions({
  questions,
  onFinish,
  trackingId,
  theme,
  onTurnChange,
  setIsCompleted,
  setResponsesPercent,
  onNewPosition,
  initStateAnswer,
  lastQuestion,
}: TProps) {
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [stateAnswer, setStateAnswer] = useState<IStateAnswer[]>([]);
  const [stateAnswerWithImage, setStateAnswerWithImage] = useState<
    IStateAnswerWithImage[]
  >([]);

  useEffect(() => {
    setCurrentIndex(0);
    setStateAnswer([]);
    if (initStateAnswer) {
      setStateAnswer(initStateAnswer);
    }
  }, [questions]);

  useEffect(() => {
    setStateAnswerWithImage(prepareStateIcon(stateAnswer));
  }, [stateAnswer]);

  function updateStateAnswer(isCorrect: boolean) {
    const newState: IStateAnswer[] = [...stateAnswer];
    newState.push({
      nb: currentIndex,
      isAnswerCorrect: isCorrect,
    });
    setStateAnswer(newState);
  }

  function prepareStateIcon(
    stateAnsw: IStateAnswer[]
  ): IStateAnswerWithImage[] {
    const newState = initState.map((item) => ({ ...item }));
    for (let i = 0; i < stateAnsw.length; i++) {
      if (i >= 0 && i < 3) {
        if (stateAnsw[i].isAnswerCorrect) {
          newState[i].image = iconGold;
        } else {
          newState[i].image = iconLost;
        }
      }
    }
    return [...newState];
  }

  function next() {
    if (questions.length === 0) return;
    if (currentIndex + 1 < questions.length) {
      setCurrentIndex((old) => old + 1);
    }
    if (currentIndex + 1 === questions.length) {
      setStateAnswer([]);

      onFinish();
    }
  }

  return (
    <Container>
      {questions.length > 0 && (
        <Qcu
          onNewPosition={onNewPosition}
          stateAnswers={stateAnswerWithImage}
          onTurnChange={onTurnChange}
          theme={theme}
          updateStateAnswer={updateStateAnswer}
          currentQuestion={questions[currentIndex]}
          nextQuestion={next}
          trackingId={trackingId}
          setIsCompleted={setIsCompleted}
          setResponsesPercent={setResponsesPercent}
          lastQuestion={lastQuestion}
        />
      )}
    </Container>
  );
}

const Container = styled.div<{ disabled?: boolean }>`
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100%;
  width: 100%;
`;
